// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationChangePasswordDefaultResponse {
    static getAttributeTypeMap() {
        return AuthenticationChangePasswordDefaultResponse.attributeTypeMap;
    }
}
AuthenticationChangePasswordDefaultResponse.discriminator = undefined;
AuthenticationChangePasswordDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Extauth2ChangePasswordStatus"
    }
];
//# sourceMappingURL=authenticationChangePasswordDefaultResponse.js.map